<template>
  <div class="winners-2019-winner">
    <div class="winners-2019-winner__main">
      <h2 class="winners-2019-winner__title">1 место</h2>
      <Winners2019WinnerUser />
    </div>
    <div class="winners-2019-winner__text">
      <p class="winners-2019-winner__text_big">
        <span class="orange">
          Поездка в Шанхай
          <br />на
        </span>
        The International 2019
      </p>
      <p class="winners-2019-winner__text_plus">+</p>
      <p>
        <span class="font-weight-medium">
          <span class="orange">Набор на</span>
          <span> 100 уровней </span>
          <span class="orange">боевого пропуска</span>
        </span>
        <br />
        <span class="winners-2019-winner__text_small">
          или Arcana
          <span class="orange">до $45</span> +
          <span class="orange">Tier-1 призы</span> от Организатора
        </span>
      </p>
    </div>
  </div>
</template>

<script>
import Winners2019WinnerUser from "./Winners2019WinnerUser";

export default {
  name: "Winners2019Winner",
  components: {
    Winners2019WinnerUser
  }
};
</script>

<style lang="scss">
.winners-2019-winner {
  border-radius: 6px;
  background: linear-gradient(180deg, rgba(#1e2135, 0.4), rgba(#304d96, 0.4)),
    url("~@/assets/img/prizes/prize-bg-1.png") center no-repeat;
  padding: 50px;
  font-family: "Montserrat";
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  &__main {
    width: 527px;
    max-width: 100%;
    background: url("~@/assets/img/prizes/shield.png") 50% 0 no-repeat;
    background-size: contain;
    min-height: 375px;
    padding: 64px 33px 48px;
    text-shadow: 0px 3px 40px #7923a6, 0px 4px 20px #000000;
    flex-shrink: 0;
    margin-right: 5px;
  }

  &__title {
    font-weight: 900;
    font-size: 80px;
    text-align: center;
    line-height: 100%;
    margin-bottom: 20px;
  }

  &__text {
    font-size: 22px;
    line-height: 1.3;
  }

  &__text_big {
    font-weight: 900;
    font-size: 40px;
    text-shadow: 0px 3px 40px #7923a6, 0px 4px 20px #000000;
  }

  &__text_plus {
    font-weight: 900;
    font-size: 75px;
    text-align: center;
  }

  &__text_small {
    font-size: 19px;
    font-weight: 400;
  }

  @include breakpoint("md-and-down") {
    flex-wrap: wrap;
    justify-content: center;
    &__main {
      margin-right: 0;
    }
    &__text {
      text-align: center;
    }
  }

  @include breakpoint("sm-and-down") {
    padding: 30px 15px;
    &__text_big {
      font-size: 30px;
    }
    &__text_plus {
      font-size: 55px;
    }
  }

  @include breakpoint("xs-only") {
    padding: 15px 15px 25px;
    &__main {
      padding: 15px 0 25px;
    }
    &__title {
      font-size: 50px;
    }
    &__text {
      font-size: 17px;
    }
    &__text_small {
      font-size: 16px;
    }
    &__text_big {
      font-size: 21px;
    }
    &__text_plus {
      font-size: 45px;
    }
  }
}
</style>
